import React, {Component, useEffect, useState} from 'react'
import {BrowserRouter, Switch, Route, Redirect } from 'react-router-dom'
import {Provider, connect} from 'react-redux'
import Login from './Login'
import {store, persistor} from '../redux/store'
import { PersistGate } from 'redux-persist/integration/react';
import Logout from './Logout'
import ModificaCorreoComponent from './aspirante/ModificaCorreoComponent'
import Aspirante from './aspirante/AspiranteComponent'
import ExitoRegistro from './aspirante/ExitoRegistro'
import CargaDocumentos from './documentacion/CargaDocumentos'
import AspiranteCompulsado from './documentacion/AspiranteCompulsado'
import SinResultadoDeCompulsa from './documentacion/SinResultadoCompulsa'
import AcudirJDE from './documentacion/AcudirJDE'
import MenuJDE from './modulosJDE/MenuJDE'
import PlaticaInduccion from './platicaInduccion/Platica'
import Cuestionario from './platicaInduccion/Cuestionario'
import ExitoPlatica from './platicaInduccion/ExitoPlatica'
import ExitoDocumentos from './documentacion/ExitoDocumentos'
import ValidaCorreo from './ValidaCorreo'
import DescargarAcuses from './documentacion/DescargarAcuses'
import EnConstruccion from './EnConstruccion'
import ValidacionDocumentos from './modulosJDE/ValidacionDocumentos'
import ReenvioAcuses from './modulosJDE/ReenvioAcuses'
import AdministrarRegistro from './modulosJDE/AdministrarRegistro'
import ComponentBandeja from "./modulosJDE/bandejaJDE/Bandeja"
import ComponentValidaBandeja from "./modulosJDE/bandejaJDE/Valida"
import ComponentModificaAspirante from "./modulosJDE/bandejaJDE/ModificaAspirante"
import SinResultados from '../componentes/SinResultados'
import OperacionExitosa from '../componentes/modulosJDE/OperacionExitosa'
import ExitoModifica from './aspirante/ExitoModifica'
import ExitoActualiza from './modulosJDE/bandejaJDE/ExitoActualiza'
import Contacto from './aspirante/Contacto'
import {visitas} from "../utils/scripts";
import Finalizado from './aspirante/Finalizado'
import SolicitudDeclinada from './aspirante/SolicitudDeclinada'
import Visor from './visor/Visor'
import AcusePlatica from './AcusePlatica'
import NoRecibiCorreo from './aspirante/NoRecibiCorreo'
import Convocatoria from './aspirante/Convocatoria'
import JuntaEjecutiva from './modulosJDE/juntaEjecutiva/JuntaEjecutiva'
import Administrador from './modulosJDE/Administrador'
import ExitoDeclinacion from './aspirante/ExitoDeclinacion'
import { withRouter } from 'react-router'
import {initGA, logPageView} from  '../analytics'

import '../css/styles.css'
import '../css/checkbox.css'
import '../css/guia_estatus.css'
import '../css/autocomplete.css'
import '../css/select.css'
import '../css/radio.css'
import '../css/mensaje.css'
import '../css/modal.css'
import '../css/calendar.css'
import '../css/template_externo.css'
import '../css/exitoInfos.css';
import packageJson from "../../package.json";
import { getBuildDate } from "../utils/utils";
import withClearCache from "../ClearCache";
import ContactoJDE from './aspirante/ContactoJDE'
import { createStructuredSelector } from 'reselect'
import { selectCurrentUser } from '../redux/user/user-selectors'
import { selectDistrito, selectEstado, selectProceso } from '../redux/menu/menu-selectors'
import { buscarLlaveValor, obtenerIpCliente, registrarBitacoraAcciones } from '../utils/funciones'
import { bitacoraAccionesNombres, idSistema } from '../ApplicationResources'
import QueHaceSEyCAE from './aspirante/QueHaceSEyCAE'

const ClearCacheComponent = withClearCache(MainApp);

function AppIni() {
  return <ClearCacheComponent />;
}

function MainApp(props) {
  return (
        <p>Build date: {getBuildDate(packageJson.buildDate)}</p>
  );
}

const registrarBitacora = async (datosUsuario, proceso, estado, distrito, bitacoraAcciones) => {
	try {
		const idProcesoElectoral = proceso ? 
			proceso.idProcesoElectoral :
			(
				datosUsuario && datosUsuario.idProcesoElectoral ? 
				datosUsuario.idProcesoElectoral : 0
			)
	
		const idDetalleProceso = proceso ? 
			proceso.idDetalleProceso :
			(
				datosUsuario && datosUsuario.idDetalle ? 
				datosUsuario.idDetalle : 0
			)

		const idEstado = estado ?
			estado.idEstado :
			(
				datosUsuario && datosUsuario.idEstado ?
				datosUsuario.idEstado : 0
			)
		
		const idDistrito = distrito ?
			distrito.idDistrito :
			(
				datosUsuario && datosUsuario.idDistrito ?
				datosUsuario.idDistrito : 0
			)

		let nivelGeografico = "OC"

		if(datosUsuario && datosUsuario.idEstado != 0) {
			if(datosUsuario.idDistrito != 0)
				nivelGeografico = "JD"
			else
			nivelGeografico = "JL"
		}

		const ipUsuario = await obtenerIpCliente()
	
		registrarBitacoraAcciones(
			idProcesoElectoral,
			idDetalleProceso,
			idSistema,
			idEstado,
			idDistrito,
			datosUsuario.username,
			datosUsuario.rolUsuario,
			nivelGeografico,
			bitacoraAcciones.valores.vista,
			bitacoraAcciones.valores.modulo,
			ipUsuario
		)
	} catch(err) {
		console.log(err)
	}
}

class App extends Component {
	constructor(props) {
		super(props);
	}

	componentDidMount = () => {

		initGA(process.env.REACT_APP_ID_GOOGLE_ANALYTICS);
        logPageView();

		// Se agrega el listener para la actualización de la url
		this.unlisten = this.props.history.listen((location, action) => {
			const { datosUsuario, proceso, estado, distrito } = this.props	
			const urlModulo = location.pathname.lastIndexOf("/") === 0 ? location.pathname : location.pathname.substring(0, location.pathname.lastIndexOf("/"))
			console.log("URL MODULO===>", urlModulo)
			const bitacoraAcciones = buscarLlaveValor(urlModulo, bitacoraAccionesNombres)
			if(datosUsuario && bitacoraAcciones)
				registrarBitacora(datosUsuario, proceso, estado, distrito, bitacoraAcciones)
		});
	}

	componentWillUnmount = () => {
		this.unlisten();
	}

	render() {
		return (
			<div className="App" onChange={visitas} onLoad={visitas}>
				<Switch>
					<Redirect exact from="/" to="/loginSEyCAE"/>
					<Redirect exact from="/loginSEyCAE.html" to="/loginSEyCAE"/>
					<Route path="/registro_aspirante" component={ (props) => (
						<Aspirante timestamp={new Date().toString()} objetos={[]} {...props} />
					)}/>
					<Route path='/menuJDE' component={MenuJDE}/>
					<Route path='/visor' component={Visor}/>
					<Route path='/validacion_documentos' component={ValidacionDocumentos}/>
					<Route path='/reenvioAcuses' component={ReenvioAcuses}/>
					<Route path='/administrarRegistro' component={AdministrarRegistro}/>
						{/* Ini: Pantallas de la bandeja JDE */}
					<Route 	path="/bandeja/modifica/:idProcesoElectoral&:idDetalleProceso&:idEstado&:idDistrito&:folioAcceso&:claveElector"
							render={props => {
							const idProcesoElectoral = props.match.params.idProcesoElectoral;
							const idDetalleProceso = props.match.params.idDetalleProceso;
							const idEstado = props.match.params.idEstado;
							const idDistrito = props.match.params.idDistrito;
							const folioAcceso = props.match.params.folioAcceso;
							const claveElector = props.match.params.claveElector;
							return (
								<ComponentModificaAspirante idProcesoElectoral={idProcesoElectoral} idDetalleProceso={idDetalleProceso} idEstado={idEstado} idDistrito={idDistrito} folio={folioAcceso} claveElector={claveElector}/>
							);
							}}
						/>
					<Route 	path="/bandeja/valida/:idProcesoElectoral&:idDetalleProceso&:claveElectorFuar&:folioAcceso"
							render={props => {
							const folioAcceso = props.match.params.folioAcceso;
							const idProcesoElectoral = props.match.params.idProcesoElectoral;
							const idDetalleProceso = props.match.params.idDetalleProceso;
							const claveElectorFuar = props.match.params.claveElectorFuar;
							
							return <ComponentValidaBandeja idProcesoElectoral={idProcesoElectoral} idDetalleProceso={idDetalleProceso} claveElectorFuar={claveElectorFuar} folioAcceso={folioAcceso} />;
							}}
						/>
					<Route path="/bandeja">
						<ComponentBandeja />
					</Route>

					<Route path="/acusePlatica" component={AcusePlatica}/>
					<Route path="/juntaEjecutiva" component={JuntaEjecutiva}/>
					<Route path="/administrador" component={Administrador}/>

					{/* Fin: Pantallas de la bandeja JDE */}
					<Route path='/modifica_correo' component={ModificaCorreoComponent}/>
					<Route path='/no_recibi_correo' component={NoRecibiCorreo}/>
					<Route path='/contacto_jde' component={ContactoJDE}/>
					<Route path='/exito_registro' component={ExitoRegistro}/>
					<Route path='/exito_modifica' component={ExitoModifica}/>
					<Route path='/exito_actualiza' component={ExitoActualiza}/>
					<Route path="/validaCorreo" component={ValidaCorreo}/>
					<Route path="/cargaDocumentos" component={CargaDocumentos}/>
					<Route path='/exitoDocumentos' component={ExitoDocumentos}/>
					<Route path='/acudirJDE' component={AcudirJDE}/>
					<Route path='/aspiranteCompulsado' component={AspiranteCompulsado}/>
					<Route path='/compulsando' component={SinResultadoDeCompulsa}/>
					<Route path="/enConstruccion" component={EnConstruccion}/>
					<Route path="/operacion_exitosa" component={OperacionExitosa}/>
					<Route path="/platica_induccion" component={PlaticaInduccion}/>
					<Route path="/cuestionario" component={Cuestionario}/>
					<Route path="/loginSEyCAE" component={Login} />
					<Route path="/exitoPlatica" component={ExitoPlatica}/>
					<Route path="/contacto" component={Contacto}/>
					<Route path="/descargar_acuses" component={DescargarAcuses}/>
					<Route path="/logout" component={Logout}/>
					<Route path="/finalizado" component={Finalizado}/>
					<Route path="/solicitud_declinada" component={SolicitudDeclinada}/>
					<Route path='/consulta_convocatoria' component={Convocatoria}/>
					<Route path='/exito_autoriza/tipoAspirante/:tieneObservaciones&:tieneDocumentacion&:conCompulsa&:idProcesoElectoral&:idDetalleProceso&:claveElectorFuar&:folioAcceso'
					render={props => {
						const tieneObservaciones = props.match.params.tieneObservaciones;
						const tieneDocumentacion = props.match.params.tieneDocumentacion;
						var conCompulsa = parseInt(props.match.params.conCompulsa);
						const folioAcceso = props.match.params.folioAcceso;
						const idProcesoElectoral = props.match.params.idProcesoElectoral;
						const idDetalleProceso = props.match.params.idDetalleProceso;
						const claveElectorFuar = props.match.params.claveElectorFuar;

						return <ComponentValidaBandeja idProcesoElectoral={idProcesoElectoral} idDetalleProceso={idDetalleProceso} claveElectorFuar={claveElectorFuar} folioAcceso={folioAcceso} conCompulsa={conCompulsa} tieneDocumentacion={tieneDocumentacion} tieneObservaciones={tieneObservaciones} />;
					}}


					/>
					<Route path='/que_hace_seycae' component={QueHaceSEyCAE}/>
					<Route path="/exito_declinacion" component={ExitoDeclinacion}/>
					<Route path="/*" component={SinResultados}/>
					

				</Switch>	
			</div>
		);
	}
}

const mapStateToProps = createStructuredSelector({
	datosUsuario: selectCurrentUser,
	proceso: selectProceso,
	estado: selectEstado,
	distrito: selectDistrito
});

export default withRouter(connect(mapStateToProps)(App));
